// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2nHGc","footer":"ReportModalFilter_footer__2c0dU"};